import { useEffect, useState, useMemo } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { postRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import { handleErrorMessages } from 'src/pages/components/errorhanling-formating';

export const TradesWorkTitleCreate = ({ open, onClose, reload, currentItem, closeform, }) => {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);

    const NewDocumentSchema = Yup.object().shape({
        // csi_code: Yup.string().required('Name is required'),
        // description: Yup.string().required('Description is required'),
        // file: Yup.array().min(1, 'Images is required'),
    });

    const defaultValues = useMemo(
        () => ({

            file: currentItem?.file || 'None',

        }),
        [ currentItem ]
    );

    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [ currentItem, reset, defaultValues ]);

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('title_code', data.title_code);
        formData.append('name', data.name);
        formData.append('title_category', data.title_category);
        formData.append('base_wage', data.base_wage);
        formData.append('suppl_benefits', data.suppl_benefits);
        formData.append('employer_taxes', data.employer_taxes);
        formData.append('workers_comp_insurance', data.workers_comp_insurance);
        formData.append('misc_expanses', data.misc_expanses);
        formData.append('regular_time_rate', data.regular_time_rate);
        formData.append('over_time_rate', data.over_time_rate);
        formData.append('double_time_rate', data.double_time_rate);
        try {
            const response = await postRequest(
                currentItem?.id
                    ? `${endpoints.admin_dashboard.teachnical_database.trade_work_title.post_list}/${currentItem.id}?_method=PUT`
                    : endpoints.admin_dashboard.teachnical_database.trade_work_title.post_list,
                formData,
                true
            );

            if (response.metadata?.success) {
                reset();
                onClose();
                reload();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });

    return (
        <Dialog
            open={ open }
            onClose={ (event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            } }
            fullWidth
            maxWidth="md"
            sx={ {
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            } }
            transitionDuration={ {
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            } }
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                    <span
                        className='cardColor'
                        style={ {
                            padding: '7px', marginLeft: '-25px', fontWeight: '700',
                            backgroundColor: "#F4F6F8",
                            color: '#637381'
                        } }
                    >
                        &nbsp;&nbsp; Trades Worker / Title &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={ onClose }>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>

                    <Box
                        mt={ 1 }
                        rowGap={ 2 }
                        gap={ 2 }
                        display="grid"
                        gridTemplateColumns={ {
                            xs: 'repeat(2, 2fr)',
                        } }
                    >
                        <RHFTextField name="title_code" label="Title Code" />
                        <RHFTextField name="name" label="Title" />
                        <RHFTextField name="title_category" label="Title Categories" />
                        <RHFTextField name="base_wage" label="Base Wage" type="number" />
                        <RHFTextField name="suppl_benefits" label="Supply Benefits" type="number" />
                        <RHFTextField name="employer_taxes" label="Employee Taxes" type="number" />
                        <RHFTextField name="workers_comp_insurance" label="Worker  Comp Insurance" type="number" />
                        <RHFTextField name="misc_expanses" label="Misc Expense" type="number" />
                        <RHFTextField name="regular_time_rate" label="Regular Time Rate " type="number" />
                        <RHFTextField name="over_time_rate" label="Over Time Rate " type="number" />
                        <RHFTextField name="double_time_rate" label="Double Time Rate " type="number" />
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={ onClose }>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        className='dark-button'
                        loading={ isSubmitting }
                    >
                        Create
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog >
    );
};